export function getCookieValue(cookieName: string): string | null {
  const cookies = document.cookie.split("; ");
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].split("=");
    const name = cookie[0];
    const value = cookie[1];
    if (name === cookieName) {
      return value;
    }
  }
  return null;
}
